/* KFH product page (kfh-product section). One script per page; each section instance is set up once. */
(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const KFH = window.KFH || {};
    const money = (c) => (KFH.money ? KFH.money(c) : `$${(c / 100).toFixed(0)}`);
    const data = JSON.parse(root.querySelector('[data-kfh-pdp-data]').textContent);
    const s = data.strings;
    const $ = (sel) => root.querySelector(sel);
    const $$ = (sel) => [...root.querySelectorAll(sel)];
    const fill = (str, amount) => (str || '').replace('[amount]', amount);

    /* ---------- State ---------- */
    const products = { single: data.single, set: data.set };
    const findById = (mode, id) => products[mode] && products[mode].variants.find((v) => v.id === id);
    const pickDefault = (mode) => {
      const p = products[mode];
      if (!p) return null;
      const avail = p.variants.filter((v) => v.available);
      return avail.find((v) => v.n === data.defaultLength && !v.blended) || null;
    };
    const state = {
      mode: data.startMode,
      chosen: { single: null, set: null },
      qty: 1,
    };
    // A ?variant= in the URL wins; otherwise preselect the default length.
    state.chosen[data.startMode] = findById(data.startMode, data.selectedId) || pickDefault(data.startMode);
    const other = data.startMode === 'single' ? 'set' : 'single';
    state.chosen[other] = pickDefault(other);

    const current = () => state.chosen[state.mode];
    // Crochet Full Install: a set length reads "18 in · Miracle Knots · 2 packs". The method switch shows that method's lengths.
    const methodOf = (v) => (v && /\d+ packs?$/.test(v.label) ? v.label.split(' · ')[1] : '');
    const packsOf = (v) => Number((v.label.match(/(\d+) packs?$/) || [])[1] || 0);
    state.method = methodOf(state.chosen.set);
    // Bundles: at fourthFrom in and longer, a set offers a 4th single bundle of the same length.
    const fourthFor = (v) => {
      if (state.mode !== 'set' || !data.fourthFrom || !v || v.blended || !products.single) return null;
      const n = Number(v.nums[0]) || v.n;
      return n >= data.fourthFrom ? products.single.variants.find((x) => x.available && x.n === n) || null : null;
    };
    let urlReady = false; // the first render keeps the URL the shopper arrived on
    const sheet = $('[data-kfh-sheet]');

    // Real saving: the single's prices for the set's lengths minus the set price.
    const setSaving = (setVariant) => {
      if (!setVariant || !products.single) return data.savingsCents;
      let sum = 0;
      for (const n of setVariant.nums) {
        const sv = products.single.variants.find((v) => v.n === Number(n));
        if (!sv) return data.savingsCents;
        sum += sv.price;
      }
      const diff = sum - setVariant.price;
      return diff > 0 ? diff : data.savingsCents;
    };

    /* ---------- Render ---------- */
    const render = () => {
      const v = current();
      const p = products[state.mode];
      const qty = state.mode === 'single' ? state.qty : 1;

      $$('[data-kfh-mode]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.kfhMode === state.mode)));
      const modeName = $('[data-kfh-mode-name]');
      if (modeName) modeName.textContent = state.mode === 'set' ? s.setName : s.singleName;
      $$('[data-kfh-only]').forEach((el) => { el.hidden = el.dataset.kfhOnly !== state.mode; });
      $$('[data-kfh-chips]').forEach((g) => { g.hidden = g.dataset.kfhChips !== state.mode; });
      $$(`[data-kfh-chips="${state.mode}"] [data-kfh-chip]`).forEach((c) => c.setAttribute('aria-checked', String(!!v && Number(c.dataset.kfhChip) === v.id)));
      const methodBtns = $$('[data-kfh-method]');
      if (methodBtns.length) {
        const m = methodOf(state.chosen.set) || state.method || methodBtns[0].dataset.kfhMethod;
        state.method = m;
        methodBtns.forEach((b) => b.setAttribute('aria-checked', String(b.dataset.kfhMethod === m)));
        $$('[data-kfh-chips="set"] [data-method]').forEach((c) => { c.hidden = c.dataset.method !== m; });
        const res = $('[data-kfh-pack-result]');
        const sv = state.chosen.set;
        if (res) res.textContent = sv ? s.packResult.replace('[count]', packsOf(sv)).replace('[pieces]', packsOf(sv) * data.packPieces) : '';
      }
      // Radio groups are one tab stop: the checked radio (or the first enabled one) takes focus.
      $$('[role="radiogroup"]').forEach((g) => {
        const radios = [...g.querySelectorAll('[role="radio"]')];
        const on = radios.find((r) => r.getAttribute('aria-checked') === 'true') || radios.find((r) => !r.disabled && !r.hidden);
        radios.forEach((r) => { r.tabIndex = r === on ? 0 : -1; });
      });

      // The chosen variant's own photo (e.g. the $50 gift card): bring it into view in the gallery.
      const chip = v && $(`[data-kfh-chip="${v.id}"][data-media]`);
      const slide = chip && $(`[data-kfh-slide][data-media-id="${chip.dataset.media}"]`);
      const track = $('[data-kfh-gallery-track]');
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });

      const title = $('[data-kfh-title]');
      if (title && p) title.textContent = p.title;
      // Keep the address bar on what's chosen (set or single page, ?variant=), so refresh and share keep it.
      if (urlReady && p && p.url) {
        const u = new URL(p.url, window.location.origin);
        if (v) u.searchParams.set('variant', v.id);
        if (u.pathname + u.search !== window.location.pathname + window.location.search) {
          window.history.replaceState(window.history.state, '', u.pathname + u.search + window.location.hash);
        }
      }
      $('[data-kfh-len-label]').textContent = `${state.mode === 'set' ? s.setLengthLabel : s.lengthLabel}:`;
      $('[data-kfh-chosen]').textContent = v
        ? (v.blended ? v.label + s.blendedSuffix : v.label + (v.landmark && !methodOf(v) ? ` · ${v.landmark}` : ''))
        : s.chooseOne;

      $('[data-kfh-price]').textContent = v ? v.priceText : `${s.from} ${money(Math.min(...p.variants.map((x) => x.price)))}`;
      const saving = $('[data-kfh-saving]');
      saving.hidden = state.mode !== 'set';
      if (state.mode === 'set') saving.textContent = fill(s.setSaving, money(setSaving(v)));

      // The set doesn't come in her single length (e.g. 26 in): say so instead of quietly switching lengths.
      const lenNote = $('[data-kfh-len-note]');
      if (lenNote) {
        lenNote.hidden = !(state.mode === 'set' && !v && state.missing && s.setMissing);
        if (!lenNote.hidden) {
          const max = Math.max(...products.set.variants.filter((x) => !x.blended).map((x) => x.n));
          lenNote.textContent = s.setMissing.replace('[max]', max).replace('[length]', state.missing)
            .replace('[count]', data.fourthFrom && state.missing >= data.fourthFrom ? 4 : 3).replace('[amount]', money(data.savingsCents));
        }
      }
      const extra = fourthFor(v);
      const fourth = $('[data-kfh-fourth]');
      if (fourth) {
        fourth.hidden = !extra;
        if (extra) {
          fourth.querySelector('[data-kfh-fourth-head]').textContent = s.fourthHead.replace('[length]', data.fourthFrom);
          fourth.querySelector('[data-kfh-fourth-text]').textContent = s.fourthText.replace('[length]', extra.n).replace('[price]', extra.priceText);
        }
      }
      const addFourth = !!extra && !!fourth && fourth.querySelector('[data-kfh-fourth-input]').checked;
      // Express checkout only buys the set; hide it while the 4th bundle is ticked so it can't be skipped.
      const dyn = $('.kfh-buy__dynamic');
      if (dyn) dyn.hidden = addFourth;

      const submit = $('[data-kfh-submit]');
      if (v) {
        submit.textContent = `${s.addToCart} · ${money(v.price * qty + (addFourth ? extra.price : 0))}`;
        submit.removeAttribute('aria-disabled');
        const vin = $('[data-kfh-variant-input]');
        if (vin.value !== String(v.id)) { vin.value = v.id; vin.dispatchEvent(new Event('change', { bubbles: true })); }
        // Shop Pay Installments only re-prices when its variant-id attribute changes. It only knows this product's
        // variants, so it hides for the Signature Set (another product) rather than quote the wrong price.
        root.querySelectorAll('shopify-payment-terms').forEach((pt) => {
          const known = (pt.getAttribute('shopify-meta') || '').includes(`"id":${v.id},`);
          pt.closest('.kfh-buy__installments').hidden = !known;
          if (known && pt.getAttribute('variant-id') !== String(v.id)) pt.setAttribute('variant-id', v.id);
        });
      } else {
        submit.textContent = s.chooseLength;
        submit.setAttribute('aria-disabled', 'true');
      }

      const total = (v ? v.price : 0) * qty;

      const qtyEl = $('[data-kfh-qty-value]');
      if (qtyEl) qtyEl.textContent = state.qty;
      const minus = $('[data-kfh-qty="-1"]');
      if (minus) minus.disabled = state.qty <= 1;

      const nudge = $('[data-kfh-nudge]');
      const amount = money(data.savingsCents);
      nudge.hidden = !(state.mode === 'single' && state.qty >= 2 && (state.qty === 2 ? s.nudge2 : s.nudge3));
      if (!nudge.hidden) nudge.textContent = fill(state.qty === 2 ? s.nudge2 : s.nudge3, amount);

      renderFigure();
      renderSticky();
      syncUpsell();
    };

    /* ---------- Option cards, chips, quantity ---------- */
    root.addEventListener('click', (e) => {
      const modeBtn = e.target.closest('[data-kfh-mode]');
      if (modeBtn) { setMode(modeBtn.dataset.kfhMode); return; }
      const methodBtn = e.target.closest('[data-kfh-method]');
      if (methodBtn) {
        // Same length in the other method when there is one.
        const was = state.chosen.set;
        const opts = products.set.variants.filter((x) => x.available && methodOf(x) === methodBtn.dataset.kfhMethod);
        state.method = methodBtn.dataset.kfhMethod;
        state.chosen.set = opts.find((x) => was && x.n === was.n) || opts.find((x) => x.n === data.defaultLength) || opts[0] || null;
        render();
        return;
      }
      const chip = e.target.closest('[data-kfh-chip]');
      if (chip && !chip.disabled) {
        state.chosen[state.mode] = findById(state.mode, Number(chip.dataset.kfhChip));
        state.missing = 0;
        $('[data-kfh-error]').hidden = true;
        render();
        return;
      }
      const q = e.target.closest('[data-kfh-qty]');
      if (q) { state.qty = Math.max(1, state.qty + Number(q.dataset.kfhQty)); render(); return; }
      if (e.target.closest('[data-kfh-add-another]')) {
        state.chosen.single = null; state.qty = 1; render();
        scrollToChips();
        return;
      }
      const chartBtn = e.target.closest('[data-kfh-chart-toggle]');
      if (chartBtn) {
        const chart = root.querySelector(`#${chartBtn.getAttribute('aria-controls')}`);
        chart.hidden = !chart.hidden;
        chartBtn.setAttribute('aria-expanded', String(!chart.hidden));
        return;
      }
      if (e.target.closest('[data-kfh-read-more]')) {
        e.preventDefault();
        const d = root.querySelector('#kfh-acc-description');
        if (d) { d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });

    root.addEventListener('change', (e) => { if (e.target.closest('[data-kfh-fourth-input]')) render(); });

    // Arrow keys move and select within a radio group (ARIA radio pattern).
    root.addEventListener('keydown', (e) => {
      const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      const r = step && e.target.closest('[role="radio"]');
      const g = r && r.closest('[role="radiogroup"]');
      if (!g) return;
      e.preventDefault();
      const radios = [...g.querySelectorAll('[role="radio"]:not(:disabled)')].filter((x) => !x.hidden);
      const next = radios[(radios.indexOf(r) + step + radios.length) % radios.length];
      next.click();
      next.focus();
    });

    const setMode = (mode) => {
      if (!products[mode] || mode === state.mode) return;
      // Keep her length across 1 Bundle / Signature Set (and 1 Pack / Full Install) when the other has it.
      const was = state.chosen[state.mode];
      const n = was && !was.blended ? Number(state.mode === 'set' ? was.nums[0] : was.n) || was.n : 0;
      state.mode = mode;
      state.qty = 1;
      state.missing = 0;
      if (n) {
        const match = products[mode].variants.find((x) => x.available && x.n === n && !x.blended && (!methodOf(x) || !state.method || methodOf(x) === state.method));
        if (match) state.chosen[mode] = match;
        else if (mode === 'set') { state.chosen.set = null; state.missing = n; }
      }
      render();
      // Signature Set picked on a single bundle page: show the set's photo (with its Bundle Deal tab); back to 1 Bundle: the first photo.
      const tr = $('[data-kfh-gallery-track]');
      const to = mode === 'set' ? $('[data-kfh-set-slide]') : $('[data-kfh-slide]');
      if (tr && to) tr.scrollTo({ left: to.offsetLeft - tr.offsetLeft, behavior: 'smooth' });
    };
    const scrollToChips = () => {
      const target = $('[data-kfh-opts]') || $(`[data-kfh-chips="${state.mode}"]`);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    // The comparison section (kfh-product-compare) asks for a mode change.
    document.addEventListener('kfh:pdp:mode', (e) => { setMode(e.detail.mode); scrollToChips(); });

    /* ---------- Add to cart ---------- */
    const add = async (btn) => {
      const v = current();
      if (!v) { scrollToChips(); const first = $(`[data-kfh-chips="${state.mode}"] [data-kfh-chip]:not(:disabled)`); if (first) first.focus({ preventScroll: true }); return; }
      const qty = state.mode === 'single' ? state.qty : 1;
      // Line item properties from the form (gift card recipient fields); disabled fields are skipped.
      const form = $('.kfh-buy__form');
      const bad = [...form.querySelectorAll('[name^="properties["]:not(:disabled)')].find((i) => !i.checkValidity());
      if (bad) { bad.reportValidity(); return; }
      const properties = {};
      form.querySelectorAll('[name^="properties["]:not(:disabled)').forEach((i) => {
        if ((i.type === 'checkbox' && !i.checked) || !i.value) return;
        properties[i.name.slice(11, -1)] = i.value;
      });
      btn.setAttribute('aria-busy', 'true');
      try {
        const items = [Object.keys(properties).length ? { id: v.id, quantity: qty, properties } : { id: v.id, quantity: qty }];
        const extra = fourthFor(v);
        const box = $('[data-kfh-fourth-input]');
        if (extra && box && box.checked) items.push({ id: extra.id, quantity: 1 });
        await KFH.addToCart(items);
      } catch (err) {
        const el = $('[data-kfh-error]');
        el.textContent = err.message || s.error;
        el.hidden = false;
      } finally {
        btn.removeAttribute('aria-busy');
      }
    };
    // Gift card recipient: show and enable the fields when "send to someone else" is ticked.
    const giftToggle = $('[data-kfh-gift-toggle]');
    if (giftToggle) {
      const fields = $('[data-kfh-gift-fields]');
      const date = $('[data-kfh-gift-date]');
      const iso = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      const today = new Date();
      date.min = iso(today);
      date.max = iso(new Date(today.getTime() + 90 * 864e5));
      $('[data-kfh-gift-offset]').value = String(today.getTimezoneOffset());
      giftToggle.addEventListener('change', () => {
        fields.hidden = !giftToggle.checked;
        fields.querySelectorAll('input, textarea').forEach((i) => { i.disabled = !giftToggle.checked; });
      });
    }
    $('.kfh-buy__form').addEventListener('submit', (e) => { e.preventDefault(); add($('[data-kfh-submit]')); });

    /* ---------- Gallery: scroll-snap track, counter, dots, desktop thumbnails ---------- */
    const track = $('[data-kfh-gallery-track]');
    const slides = $$('[data-kfh-slide]');
    const dots = $('[data-kfh-gallery-dots]');
    const thumbs = $('[data-kfh-gallery-thumbs]');
    $('[data-kfh-gallery-total]').textContent = slides.length;
    slides.forEach((slide, i) => {
      const dot = document.createElement('span');
      dots.appendChild(dot);
      const th = document.createElement('button');
      th.type = 'button';
      th.tabIndex = -1;
      const name = slide.dataset.thumbName || slide.querySelector('img[alt]:not([alt=""])')?.alt || slide.dataset.thumbLabel;
      th.setAttribute('aria-label', `${name ? `${name}, ` : ''}${i + 1} / ${slides.length}`);
      if (slide.dataset.thumb) th.style.backgroundImage = `url("${slide.dataset.thumb}")`;
      else if (slide.dataset.thumbIcon === 'ruler') {
        // "Find your length" slide: a small ruler + label instead of a photo.
        th.classList.add('is-icon');
        th.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" style="width:18px;height:18px;fill:none;stroke:currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><rect x="3" y="8" width="18" height="8" rx="1.5"/><path d="M7 8v3M11 8v4M15 8v3M19 8v2"/></svg>';
        if (slide.dataset.thumbLabel) th.append(Object.assign(document.createElement('span'), { textContent: slide.dataset.thumbLabel }));
      } else th.textContent = slide.dataset.thumbLabel || '';
      th.addEventListener('click', () => track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }));
      thumbs.appendChild(th);
      if (i === 0) { dot.className = 'is-on'; th.className = 'is-on'; }
    });
    if (slides.length < 2) { dots.hidden = true; thumbs.hidden = true; }
    else $('.kfh-gallery__main').classList.add('has-thumbs');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const i = slides.indexOf(en.target);
        $('[data-kfh-gallery-current]').textContent = i + 1;
        [...dots.children].forEach((d, k) => d.classList.toggle('is-on', k === i));
        [...thumbs.children].forEach((d, k) => d.classList.toggle('is-on', k === i));
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach((sl) => io.observe(sl));
    // Tap or click a product photo: full resolution in a dialog (Esc, tap or the button closes). No hover zoom.
    track.addEventListener('click', (e) => {
      const slide = e.target.closest('[data-kfh-zoom]');
      const img = slide && e.target.closest('img');
      if (!img) return;
      let dlg = document.querySelector('.kfh-zoom');
      if (!dlg) {
        dlg = Object.assign(document.createElement('dialog'), { className: 'kfh-zoom' });
        dlg.innerHTML = '<img alt=""><button type="button" aria-label="Close">×</button>';
        dlg.addEventListener('click', () => dlg.close());
        document.body.append(dlg);
      }
      const big = dlg.querySelector('img');
      big.src = slide.dataset.kfhZoom;
      big.alt = img.alt;
      dlg.showModal();
    });

    /* ---------- Length figure (ported from the design's fig()) ---------- */
    const figure = $('[data-kfh-figure]');
    const YL = { 12: 70, 14: 95, 16: 118, 18: 145, 20: 170, 22: 195, 24: 218, 26: 255, 28: 288 };
    const shape = { straight: 0, body_wave: 1, loose_wave: 2, curly: 3 }[data.hairShape] ?? 0;
    const figLengths = products.single ? products.single.variants.filter((v) => YL[v.n]) : [];
    function renderFigure() {
      if (!figure || !figLengths.length || !window.KFH || !window.KFH.drawFigure) return;
      const sv = state.chosen.single;
      const len = sv && YL[sv.n] ? sv.n : data.defaultLength;
      window.KFH.drawFigure(figure, {
        len, shape,
        lengths: figLengths.map((v) => ({ n: v.n, label: v.landmark ? `${v.n} in · ${v.landmark}` : `${v.n} in`, available: v.available, v })),
        onPick: (m) => { state.mode = 'single'; state.chosen.single = m.v; render(); },
      });
    }

    /* ---------- Sticky add to cart ---------- */
    const sticky = $('[data-kfh-sticky]');
    const stickySelect = $('[data-kfh-sticky-select]');
    function renderSticky() {
      if (!sticky) return;
      const p = products[state.mode];
      const v = current();
      // "· 1 Bundle / Signature Set" only where there's a bundle choice; wigs, closures and crochet show just the name.
      const modeLabel = data.set ? ` · ${state.mode === 'set' ? s.setName : s.singleName}${state.mode === 'single' && state.qty > 1 ? ` × ${state.qty}` : ''}` : '';
      sticky.querySelector('[data-kfh-sticky-name]').textContent = `${p.title.replace(/ Signature Set$/, '')}${modeLabel}`;
      sticky.querySelector('[data-kfh-sticky-sub]').textContent = v ? (v.blended ? v.label + s.blendedSuffix : v.label) : s.chooseOne;
      stickySelect.replaceChildren(new Option(state.mode === 'set' ? s.setLengthLabel : s.lengthLabel, ''), ...p.variants.filter((x) => x.available).map((x) => new Option(x.label, x.id, false, !!v && x.id === v.id)));
      const btn = sticky.querySelector('[data-kfh-sticky-btn]');
      btn.textContent = v ? `${s.addToCart} · ${money(v.price * (state.mode === 'single' ? state.qty : 1))}` : s.chooseLength;
      btn.toggleAttribute('aria-disabled', !v);
    }
    if (sticky) {
      stickySelect.addEventListener('change', () => { state.chosen[state.mode] = findById(state.mode, Number(stickySelect.value)) || null; render(); });
      sticky.querySelector('[data-kfh-sticky-btn]').addEventListener('click', (e) => add(e.currentTarget));
      const atcRow = $('[data-kfh-atc-row]');
      const mobile = window.matchMedia('(max-width: 989px)');
      const html = document.documentElement;
      let rowGone = false;
      let footerIn = false;
      let buttonUnder = false;
      const show = () => {
        const on = rowGone && !footerIn && !buttonUnder && !(sheet && sheet.open);
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        sticky.querySelectorAll('select, button').forEach((n) => { n.tabIndex = on ? 0 : -1; });
        // App launchers (Klaviyo teaser, Smile): never over the gallery/buy box, and on mobile not under the bar.
        const pdpBottom = root.getBoundingClientRect().bottom;
        const pdpLow = pdpBottom > window.innerHeight - 120;
        html.classList.toggle('kfh-hide-launchers', pdpLow || (mobile.matches && on));
        html.classList.toggle('kfh-sticky-on', on);
      };
      // Position check on scroll (an IntersectionObserver misses jumps that skip past the row).
      const footer = document.querySelector('.kfh-foot-wrap, footer');
      // Controls the bar must never sit on: buttons, selects and button-links in the KFH sections.
      const controls = () => [...document.querySelectorAll('.kfh-page button, .kfh-page select, .kfh-page a.kfh-btn')]
        .filter((n) => !sticky.contains(n) && !n.closest('.kfh-gallery__thumbs, [hidden], dialog'));
      const check = () => {
        rowGone = atcRow.getBoundingClientRect().bottom < 0;
        footerIn = !!footer && footer.getBoundingClientRect().top < window.innerHeight;
        const barTop = window.innerHeight - (mobile.matches ? 16 : 24) - (sticky.offsetHeight || 60) - 8;
        buttonUnder = rowGone && controls().some((n) => {
          const r = n.getBoundingClientRect();
          return r.width > 0 && r.bottom > barTop && r.top < window.innerHeight;
        });
        show();
      };
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; check(); });
      }, { passive: true });
      window.addEventListener('resize', check);
      check();
    }

    /* ---------- Closure upsell: default to the chosen bundle length ---------- */
    function syncUpsell() {
      const n = state.chosen.single ? state.chosen.single.n : (state.chosen.set ? Number(state.chosen.set.nums[0]) : null);
      $$('[data-kfh-upsell]').forEach((card) => {
        const sel = card.querySelector('[data-kfh-upsell-select]');
        if (card.dataset.touched) return;
        const match = [...sel.options].find((o) => Number(o.dataset.n) === n);
        if (match) sel.value = match.value;
        card.querySelector('[data-kfh-upsell-price]').textContent = sel.selectedOptions[0].dataset.price;
      });
    }
    root.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-kfh-upsell-select]');
      if (!sel) return;
      const card = sel.closest('[data-kfh-upsell]');
      card.dataset.touched = '1';
      card.querySelector('[data-kfh-upsell-price]').textContent = sel.selectedOptions[0].dataset.price;
    });
    root.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-kfh-upsell-add]');
      if (!btn) return;
      const card = btn.closest('[data-kfh-upsell]');
      btn.setAttribute('aria-busy', 'true');
      try {
        await KFH.addToCart([{ id: Number(card.querySelector('[data-kfh-upsell-select]').value), quantity: 1 }]);
        btn.textContent = `${s.added} ✓`;
        btn.classList.add('is-added');
      } catch (err) { /* the drawer shows the cart state */ }
      btn.removeAttribute('aria-busy');
    });

    /* ---------- Signature Set details sheet (native <dialog>) ---------- */
    if (sheet) {
      const open = (e) => { e.preventDefault(); e.stopPropagation(); sheet.showModal(); };
      root.querySelectorAll('[data-kfh-sheet-open]').forEach((el) => el.addEventListener('click', open));
      sheet.querySelector('[data-kfh-sheet-close]').addEventListener('click', () => sheet.close());
      sheet.addEventListener('click', (e) => { if (e.target === sheet) sheet.close(); });
      sheet.querySelector('[data-kfh-sheet-choose]').addEventListener('click', () => { sheet.close(); setMode('set'); });
    }

    render();
    urlReady = true;
  };

  const boot = () => document.querySelectorAll('[data-kfh-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
